(function () {
  'use strict';

  var ENDPOINT = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/quick-price-chat';

  // The four fence types we can quick-price. These strings are the contract with
  // the edge function's FENCE_TYPES map - don't rename one side only.
  var FENCE_TYPES = ['Frameless Glass', 'PerfMesh', 'Blade', 'Flat Top'];

  // Where "get your exact price" goes. The calculator prices a real parts list;
  // this widget only ever gives a guide, so every priced screen offers the way
  // to the exact number. Keys must match FENCE_TYPES above.
  var CALC_URLS = {
    'Frameless Glass': '/pages/glass-fencing',
    'PerfMesh': '/pages/perfmesh-fence',
    'Blade': '/pages/blade-fence-calculator',
    'Flat Top': '/pages/flat-top-fence-calculator'
  };

  // ---------------------------------------------------------------------
  // Styles
  // ---------------------------------------------------------------------
  var css = '\n'
    + '#qpw-bubble{position:fixed;bottom:20px;right:20px;width:60px;height:60px;border-radius:50%;background:#0f3d3e;box-shadow:0 4px 16px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:999999;transition:transform .15s ease;}'
    + '#qpw-bubble:hover{transform:scale(1.06);}'
    + '#qpw-bubble svg{width:28px;height:28px;fill:#fff;}'
    + '#qpw-panel{position:fixed;bottom:92px;right:20px;width:340px;max-width:calc(100vw - 32px);max-height:70vh;background:#fff;border-radius:14px;box-shadow:0 10px 40px rgba(0,0,0,.25);display:none;flex-direction:column;overflow:hidden;z-index:999999;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}'
    + '#qpw-panel.qpw-open{display:flex;}'
    + '#qpw-header{background:#0f3d3e;color:#fff;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}'
    + '#qpw-header h3{margin:0;font-size:15px;font-weight:600;}'
    + '#qpw-header p{margin:2px 0 0;font-size:12px;opacity:.75;}'
    + '#qpw-close{cursor:pointer;opacity:.8;font-size:20px;line-height:1;background:none;border:none;color:#fff;padding:4px;}'
    + '#qpw-close:hover{opacity:1;}'
    + '#qpw-body{padding:16px;overflow-y:auto;flex:1;background:#f7f8f7;}'
    + '.qpw-msg{background:#fff;border-radius:10px;padding:10px 12px;margin-bottom:10px;font-size:13.5px;line-height:1.45;color:#1b2523;box-shadow:0 1px 3px rgba(0,0,0,.06);}'
    + '.qpw-options{display:flex;flex-direction:column;gap:8px;margin-bottom:10px;}'
    + '.qpw-opt{background:#fff;border:1.5px solid #d8ded9;border-radius:8px;padding:9px 12px;font-size:13.5px;text-align:left;cursor:pointer;color:#0f3d3e;font-weight:500;transition:border-color .12s,background .12s;}'
    + '.qpw-opt:hover{border-color:#0f3d3e;background:#eef4f2;}'
    + '.qpw-opt.qpw-opt-secondary{color:#556;border-style:dashed;}'
    + '.qpw-inputwrap{background:#fff;border-radius:10px;padding:12px;margin-bottom:10px;box-shadow:0 1px 3px rgba(0,0,0,.06);}'
    + '.qpw-inputwrap label{display:block;font-size:12px;color:#556;margin-bottom:6px;font-weight:500;}'
    + '.qpw-inputwrap input,.qpw-inputwrap textarea{width:100%;box-sizing:border-box;border:1.5px solid #d8ded9;border-radius:7px;padding:8px 10px;font-size:14px;margin-bottom:8px;font-family:inherit;}'
    + '.qpw-inputwrap textarea{resize:vertical;min-height:70px;}'
    + '.qpw-stepper{display:flex;align-items:center;gap:10px;margin-bottom:8px;}'
    + '.qpw-stepper button{width:28px;height:28px;border-radius:6px;border:1.5px solid #d8ded9;background:#fff;font-size:16px;cursor:pointer;color:#0f3d3e;}'
    + '.qpw-stepper span{font-size:14px;min-width:16px;text-align:center;}'
    + '.qpw-primary{width:100%;background:#0f3d3e;color:#fff;border:none;border-radius:7px;padding:10px;font-size:13.5px;font-weight:600;cursor:pointer;}'
    + '.qpw-primary:hover{background:#154f50;}'
    + '.qpw-primary:disabled{opacity:.5;cursor:default;}'
    + '.qpw-link{background:none;border:none;color:#0f3d3e;text-decoration:underline;font-size:12.5px;cursor:pointer;padding:0;margin-top:2px;display:block;}'
    + '.qpw-footer{display:flex;flex-direction:column;align-items:center;gap:4px;margin-top:6px;}'
    + '.qpw-restart{display:block;background:none;border:none;color:#6b7570;font-size:12px;text-decoration:underline;cursor:pointer;}'
    + '.qpw-spinner{display:inline-block;width:14px;height:14px;border:2px solid #cfd9d6;border-top-color:#0f3d3e;border-radius:50%;animation:qpwspin .7s linear infinite;vertical-align:middle;margin-right:6px;}'
    + '@keyframes qpwspin{to{transform:rotate(360deg);}}'
    + '.qpw-error{color:#b3261e;}'
    + '.qpw-fielderr{color:#b3261e;font-size:12.5px;line-height:1.35;margin:2px 0 6px;min-height:0;}'
    + '.qpw-invalid{border-color:#b3261e !important;}'
    + '.qpw-help{font-size:11.5px;color:#6b7570;margin:-2px 0 6px;line-height:1.35;}'
    /* Itemised card - still used by the Supply & Install path, whose figures come
       from the live rate card and are real. DIY no longer uses it: see below. */
    + '.qpw-quote{background:#fff;border-radius:10px;padding:12px;margin-bottom:10px;box-shadow:0 1px 3px rgba(0,0,0,.06);font-size:13px;}'
    + '.qpw-qline{display:flex;justify-content:space-between;gap:12px;padding:4px 0;color:#1b2523;}'
    + '.qpw-qline span:last-child{white-space:nowrap;font-variant-numeric:tabular-nums;}'
    + '.qpw-qsub{border-top:1px solid #e6eae8;margin-top:4px;padding-top:8px;font-weight:600;}'
    + '.qpw-qtotal{border-top:2px solid #0f3d3e;margin-top:4px;padding-top:8px;font-weight:700;font-size:15px;color:#0f3d3e;}'
    /* GUIDE RANGE CARD (3 Sep 2026). Replaces the old itemised total with its own
       GST line. That layout looked like a quote, and the number behind it was out
       by up to 105% on flat top - three questions cannot price a parts list. */
    + '.qpw-guide{background:#fff;border-radius:10px;padding:14px;margin-bottom:10px;box-shadow:0 1px 3px rgba(0,0,0,.06);border-left:3px solid #0f3d3e;}'
    + '.qpw-guide__label{font-size:11px;text-transform:uppercase;letter-spacing:.07em;color:#6b7570;font-weight:700;}'
    + '.qpw-guide__range{font-size:24px;font-weight:700;color:#0f3d3e;line-height:1.15;margin:6px 0 2px;font-variant-numeric:tabular-nums;}'
    + '.qpw-guide__job{font-size:12.5px;color:#4a5654;}'
    + '.qpw-guide__gst{font-size:11.5px;color:#6b7570;margin-top:4px;}'
    + '.qpw-cta{display:block;width:100%;box-sizing:border-box;text-align:center;background:#0f3d3e;color:#fff;border:none;border-radius:7px;padding:11px;font-size:13.5px;font-weight:600;cursor:pointer;text-decoration:none;margin-bottom:10px;}'
    + '.qpw-cta:hover{background:#154f50;color:#fff;text-decoration:none;}'
    /* Shopify Inbox ships its own chat bubble via a theme app embed, which sat in
       the same corner as this widget. Pete (29 Jul) chose to keep THIS one.
       Delete this one rule to bring Inbox back. */
    + 'shopify-chat{display:none !important;}'
    + '@media(max-width:420px){#qpw-panel{right:16px;bottom:84px;width:calc(100vw - 32px);}}';

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ---------------------------------------------------------------------
  // DOM scaffold
  // ---------------------------------------------------------------------
  var bubble = document.createElement('div');
  bubble.id = 'qpw-bubble';
  bubble.innerHTML = '<svg viewBox="0 0 24 24"><path d="M4 4h16a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H8l-4 4v-4H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/></svg>';
  document.body.appendChild(bubble);

  var panel = document.createElement('div');
  panel.id = 'qpw-panel';
  panel.innerHTML =
    '<div id="qpw-header"><div><h3>Quick Price</h3><p>Get a fast fencing estimate</p></div><button id="qpw-close" aria-label="Close">&times;</button></div>'
    + '<div id="qpw-body"></div>';
  document.body.appendChild(panel);

  var body = panel.querySelector('#qpw-body');

  bubble.addEventListener('click', function () {
    panel.classList.toggle('qpw-open');
    if (panel.classList.contains('qpw-open') && !body.dataset.started) {
      body.dataset.started = '1';
      renderStart();
    }
  });
  panel.querySelector('#qpw-close').addEventListener('click', function () {
    panel.classList.remove('qpw-open');
  });

  function clearBody() { body.innerHTML = ''; }

  function addMsg(html, cls) {
    var d = document.createElement('div');
    d.className = 'qpw-msg' + (cls ? ' ' + cls : '');
    d.innerHTML = html;
    body.appendChild(d);
    body.scrollTop = body.scrollHeight;
    return d;
  }

  function addOptions(labels, onPick) {
    var wrap = document.createElement('div');
    wrap.className = 'qpw-options';
    labels.forEach(function (label) {
      var btn = document.createElement('button');
      btn.className = 'qpw-opt';
      btn.type = 'button';
      btn.textContent = label;
      btn.addEventListener('click', function () { onPick(label); });
      wrap.appendChild(btn);
    });
    body.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
    return wrap;
  }

  // "Get your exact price" - the calculator prices a real parts list, so it is
  // always the honest next step from a guide.
  function addCalculatorCta(material, label) {
    var url = CALC_URLS[material];
    if (!url) return;
    var a = document.createElement('a');
    a.className = 'qpw-cta';
    a.href = url;
    a.textContent = label || 'Get your exact price';
    body.appendChild(a);
    body.scrollTop = body.scrollHeight;
  }

  function addFooter(opts) {
    opts = opts || {};
    var wrap = document.createElement('div');
    wrap.className = 'qpw-footer';
    if (opts.showMessage !== false) {
      var msgBtn = document.createElement('button');
      msgBtn.className = 'qpw-restart';
      msgBtn.type = 'button';
      msgBtn.textContent = 'Send us a message instead';
      msgBtn.addEventListener('click', function () { clearBody(); renderMessageForm(); });
      wrap.appendChild(msgBtn);
    }
    var restartBtn = document.createElement('button');
    restartBtn.className = 'qpw-restart';
    restartBtn.type = 'button';
    restartBtn.textContent = 'Start a new estimate';
    restartBtn.addEventListener('click', function () { clearBody(); renderStart(); });
    wrap.appendChild(restartBtn);
    body.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
  }

  function callApi(payload) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  // ---------------------------------------------------------------------
  // Flow
  // ---------------------------------------------------------------------
  function renderStart() {
    addMsg('Hi! Let us get you a rough price. What type of fence are you after?');
    var wrap = document.createElement('div');
    wrap.className = 'qpw-options';
    FENCE_TYPES.forEach(function (type) {
      var btn = document.createElement('button');
      btn.className = 'qpw-opt';
      btn.type = 'button';
      btn.textContent = type;
      btn.addEventListener('click', function () { renderModeChoice(type); });
      wrap.appendChild(btn);
    });
    var msgBtn = document.createElement('button');
    msgBtn.className = 'qpw-opt qpw-opt-secondary';
    msgBtn.type = 'button';
    msgBtn.textContent = 'Send us a message';
    msgBtn.addEventListener('click', function () { clearBody(); renderMessageForm(); });
    wrap.appendChild(msgBtn);
    body.appendChild(wrap);
  }

  function renderMessageForm() {
    addMsg('No worries - what would you like to ask us? We will get back to you by email.');
    var wrap = document.createElement('div');
    wrap.className = 'qpw-inputwrap';
    wrap.innerHTML = '<label>Your name (optional)</label><input type="text" placeholder="Your name" id="qpw-msg-name"/>'
      + '<label>Your email</label><input type="email" placeholder="you@example.com" id="qpw-msg-email"/>'
      + '<label>Your phone number</label><input type="tel" placeholder="04xx xxx xxx" id="qpw-msg-phone"/>'
      + '<label>Suburb</label><input type="text" placeholder="e.g. Joondalup" id="qpw-msg-suburb"/>'
      + '<label>Message</label><textarea id="qpw-msg-text" placeholder="Type your question or message"></textarea>'
      + '<div class="qpw-fielderr" id="qpw-msg-err"></div>'
      + '<button class="qpw-primary" type="button">Send message</button>';
    body.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
    var nameInput = wrap.querySelector('#qpw-msg-name');
    var emailInput = wrap.querySelector('#qpw-msg-email');
    var phoneInput = wrap.querySelector('#qpw-msg-phone');
    var suburbInput = wrap.querySelector('#qpw-msg-suburb');
    var textInput = wrap.querySelector('#qpw-msg-text');
    var btn = wrap.querySelector('.qpw-primary');
    var errEl = wrap.querySelector('#qpw-msg-err');
    function fail(input, message) {
      errEl.textContent = message;
      [emailInput, phoneInput, suburbInput, textInput].forEach(function (el) { el.classList.remove('qpw-invalid'); });
      input.classList.add('qpw-invalid');
      input.focus();
    }
    btn.addEventListener('click', function () {
      var email = (emailInput.value || '').trim();
      var phone = (phoneInput.value || '').trim();
      var suburb = (suburbInput.value || '').trim();
      var msg = (textInput.value || '').trim();
      if (!email || email.indexOf('@') === -1) { fail(emailInput, 'Please enter a valid email address so we can reply.'); return; }
      if (!phone) { fail(phoneInput, 'Please enter a phone number.'); return; }
      if (!suburb) { fail(suburbInput, 'Please enter your suburb.'); return; }
      if (!msg) { fail(textInput, 'Please type your message.'); return; }
      errEl.textContent = '';
      [emailInput, phoneInput, suburbInput, textInput].forEach(function (el) { el.classList.remove('qpw-invalid'); });
      btn.disabled = true;
      btn.innerHTML = '<span class="qpw-spinner"></span>Sending';
      callApi({ action: 'send_message', name: nameInput.value, email: email, phone: phone, suburb: suburb, message: msg }).then(function (res) {
        clearBody();
        if (res.error) { addMsg('Sorry - ' + res.error, 'qpw-error'); }
        else { addMsg('Thanks! Your message has been sent to our team - we will get back to you by email soon.'); }
        addFooter({ showMessage: false });
      }).catch(function () {
        clearBody();
        addMsg('Something went wrong sending that. Please try again shortly.', 'qpw-error');
        addFooter({ showMessage: false });
      });
    });
    addFooter({ showMessage: false });
  }

  function addStepper(wrap, id, labelText, helpText) {
    var lab = document.createElement('label');
    lab.textContent = labelText;
    wrap.appendChild(lab);
    if (helpText) {
      var help = document.createElement('div');
      help.className = 'qpw-help';
      help.textContent = helpText;
      wrap.appendChild(help);
    }
    var row = document.createElement('div');
    row.className = 'qpw-stepper';
    row.innerHTML = '<button type="button" data-d="-1">-</button><span id="' + id + '">0</span><button type="button" data-d="1">+</button>';
    wrap.appendChild(row);
    var span = row.querySelector('#' + id);
    var n = 0;
    row.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        n = Math.max(0, Math.min(20, n + Number(b.getAttribute('data-d'))));
        span.textContent = n;
      });
    });
    return function () { return n; };
  }

  function renderModeChoice(material) {
    clearBody();
    addMsg(material + ' - are you installing it yourself, or would you like us to install it for you?');
    addOptions(['DIY / Supply Only', 'Supply & Install'], function (label) {
      renderJobForm(material, label === 'Supply & Install' ? 'si' : 'diy');
    });
    addFooter();
  }

  function renderJobForm(material, mode) {
    clearBody();
    addMsg('Great. Three quick numbers and I will price it up.');
    var wrap = document.createElement('div');
    wrap.className = 'qpw-inputwrap';

    var mLab = document.createElement('label');
    mLab.textContent = 'Total metres of fencing';
    wrap.appendChild(mLab);
    var mInput = document.createElement('input');
    mInput.type = 'number'; mInput.min = '1'; mInput.step = '0.5';
    mInput.placeholder = 'e.g. 12';
    mInput.id = 'qpw-m';
    wrap.appendChild(mInput);

    var getGates = addStepper(wrap, 'qpw-gates', 'How many gates?', null);
    var getRakes = addStepper(wrap, 'qpw-rakes', 'How many step-ups in the fence line?',
      'A step-up is where the ground slopes or steps and the panel has to follow it. Leave at 0 if your fence line is flat.');

    var err = document.createElement('div');
    err.className = 'qpw-fielderr'; err.id = 'qpw-job-err';
    wrap.appendChild(err);

    var btn = document.createElement('button');
    btn.className = 'qpw-primary'; btn.type = 'button';
    btn.textContent = 'Get my estimate';
    wrap.appendChild(btn);
    body.appendChild(wrap);
    body.scrollTop = body.scrollHeight;

    btn.addEventListener('click', function () {
      var m = parseFloat(mInput.value);
      if (!m || m <= 0) {
        err.textContent = 'Please enter how many metres of fencing you need.';
        mInput.classList.add('qpw-invalid'); mInput.focus(); return;
      }
      err.textContent = ''; mInput.classList.remove('qpw-invalid');
      btn.disabled = true;
      btn.innerHTML = '<span class="qpw-spinner"></span>Working it out';
      callApi({
        action: 'estimate', material: material, mode: mode,
        total_meters: m, gates: getGates(), rakes: getRakes()
      }).then(function (res) {
        clearBody();
        // too_short is checked BEFORE error: the server sets both, so a browser
        // still running an older widget shows the message rather than rendering
        // an absent total as "$0.00".
        if (res.too_short) { renderTooShort(res, material); return; }
        if (res.error) { addMsg('Sorry - ' + res.error, 'qpw-error'); addFooter(); return; }
        renderEstimate(res, material, mode);
      }).catch(function () {
        clearBody();
        addMsg('Something went wrong working that out. Please try again shortly.', 'qpw-error');
        addFooter();
      });
    });
    addFooter();
  }

  // Defensive: the server prices short runs now, but if it ever declines to, say
  // so plainly and hand over to the calculator rather than show a bad number.
  function renderTooShort(res, material) {
    addMsg('For ' + material + ', ' + (res.message || 'a run this short is best priced properly.'));
    addCalculatorCta(material, 'Price it exactly');
    addFooter();
  }

  // The price screen.
  //
  // DIY gets a RANGE and no tax line. The old layout itemised every charge and
  // added GST underneath, which reads as a quote; the number behind it was out by
  // up to 105% on flat top, because three questions cannot price a parts list.
  // Supply & Install keeps its itemisation - that path uses the live rate card
  // and its figures are real.
  function renderEstimate(res, material, mode) {
    var money2 = function (n) {
      return '$' + Number(n || 0).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    var money0 = function (n) {
      return '$' + Number(n || 0).toLocaleString('en-AU', { maximumFractionDigits: 0 });
    };

    var summary;

    if (mode === 'diy' && res.guide) {
      addMsg('Here is the guide price for <strong>' + material + '</strong> - supply only.');

      var card = document.createElement('div');
      card.className = 'qpw-guide';
      card.innerHTML =
        '<div class="qpw-guide__label">Guide price</div>'
        + '<div class="qpw-guide__range">' + money0(res.guide.low_inc) + ' - ' + money0(res.guide.high_inc) + '</div>'
        + '<div class="qpw-guide__job">' + (res.job || '') + '</div>'
        + '<div class="qpw-guide__gst">Includes GST. Delivery not included.</div>';
      body.appendChild(card);

      if (res.includes_note) addMsg('<em>' + res.includes_note + '</em>');
      // Only present on a short run, where posts and fixings are a bigger share of
      // the cost and the guide is correspondingly less certain.
      if (res.short_run_note) addMsg('<em>' + res.short_run_note + '</em>');
      if (res.caveat) addMsg('<em>' + res.caveat + '</em>');
      if (res.delivery_note) addMsg('<em>' + res.delivery_note + '</em>');

      addCalculatorCta(material, 'Get your exact price');

      summary = material + ' - DIY / Supply Only\n'
        + (res.job || '') + '\n'
        + 'Guide price (inc GST): ' + money0(res.guide.low_inc) + ' - ' + money0(res.guide.high_inc);
    } else {
      addMsg('Here is a rough price for <strong>' + material + '</strong> - '
        + (mode === 'si' ? 'supplied and installed' : 'supply only') + '.');

      var quote = document.createElement('div');
      quote.className = 'qpw-quote';
      var html = '';
      (res.lines || []).forEach(function (l) {
        html += '<div class="qpw-qline"><span>' + l.label + '</span><span>' + money2(l.amount) + '</span></div>';
      });
      html += '<div class="qpw-qline qpw-qsub"><span>Subtotal (ex GST)</span><span>' + money2(res.ex_gst) + '</span></div>';
      html += '<div class="qpw-qline"><span>GST (10%)</span><span>' + money2(res.gst) + '</span></div>';
      html += '<div class="qpw-qline qpw-qtotal"><span>Total (inc GST)</span><span>' + money2(res.inc_gst) + '</span></div>';
      quote.innerHTML = html;
      body.appendChild(quote);

      if (res.includes_note) addMsg('<em>' + res.includes_note + '</em>');
      if (res.delivery_note) addMsg('<em>' + res.delivery_note + '</em>');
      if (res.caveat) addMsg('<em>' + res.caveat + '</em>');

      summary = material + ' - ' + (mode === 'si' ? 'Supply & Install' : 'DIY / Supply Only') + '\n'
        + res.billed_lm + 'Lm'
        + (res.gates ? ', ' + res.gates + ' gate' + (res.gates === 1 ? '' : 's') : '')
        + (res.rakes ? ', ' + res.rakes + ' step-up' + (res.rakes === 1 ? '' : 's') : '') + '\n'
        + 'Subtotal (ex GST): ' + money2(res.ex_gst) + '\n'
        + 'GST: ' + money2(res.gst) + '\n'
        + 'Total (inc GST): ' + money2(res.inc_gst);
    }

    offerEmail(summary);
    addFooter();
  }

  function offerEmail(summary) {
    var link = document.createElement('button');
    link.className = 'qpw-link';
    link.type = 'button';
    link.textContent = 'Email me this price';
    body.appendChild(link);
    body.scrollTop = body.scrollHeight;
    link.addEventListener('click', function () {
      link.remove();
      var wrap = document.createElement('div');
      wrap.className = 'qpw-inputwrap';
      wrap.innerHTML = '<label>Your email</label><input type="email" placeholder="you@example.com" id="qpw-email"/>'
        + '<div class="qpw-fielderr" id="qpw-email-err"></div>'
        + '<button class="qpw-primary" type="button">Send</button>';
      body.appendChild(wrap);
      body.scrollTop = body.scrollHeight;
      var input = wrap.querySelector('#qpw-email');
      var errEl = wrap.querySelector('#qpw-email-err');
      var btn = wrap.querySelector('.qpw-primary');
      btn.addEventListener('click', function () {
        var email = (input.value || '').trim();
        if (!email || email.indexOf('@') === -1) {
          errEl.textContent = 'Please enter a valid email address.';
          input.classList.add('qpw-invalid'); input.focus(); return;
        }
        errEl.textContent = ''; input.classList.remove('qpw-invalid');
        btn.disabled = true;
        btn.innerHTML = '<span class="qpw-spinner"></span>Sending';
        callApi({ action: 'send_estimate', email: email, summary: summary }).then(function (res) {
          wrap.remove();
          if (res.error) { addMsg('Could not send that - ' + res.error, 'qpw-error'); }
          else { addMsg('Sent! Check your inbox.'); }
        }).catch(function () {
          wrap.remove();
          addMsg('Could not send that right now.', 'qpw-error');
        });
      });
    });
  }
})();
